<div class="reward-membership-card-container" *ngIf="isRewardPage && displayedMembership.length > 0">
  <div class="membership-card-content" *ngFor="let itm of displayedMembership" (click)="onClickMember(itm)">
    <!--with card image-->
    <img [src]="itm.cardImageData | storeImage" onerror="this.src='assets/image-unavailable.svg'" alt="membership card"
      [ngStyle]="{'filter': isExpired(itm.expiryDate) ? 'opacity(0.7)' : 'opacity(1)' }"
      [ngClass]="{'greyScale': isExpired(itm.expiryDate)}" *ngIf="itm.cardImageData"
      class="card-image" loading="lazy" />

    <div class="logo-image-container" *ngIf="itm.logoImageData && !itm.cardImageData"
      [ngStyle]="{'filter': isExpired(itm.expiryDate) ? 'opacity(0.7)' : 'opacity(1)' }"
      [ngClass]="{'greyScale': isExpired(itm.expiryDate)}">
      <img [src]="itm.logoImageData | storeImage" onerror="this.src='assets/image-unavailable.svg'" alt="image unavailable"
        loading="lazy" />
    </div>

    <div class="membership-info-content">
      <h1 class="bold" *ngIf="itm.membershipDesc"
        [ngStyle]="{'filter': isExpired(itm.expiryDate) ? 'opacity(0.7)' : 'opacity(1)' }">{{itm.membershipDesc}}</h1>
      <span class="level" *ngIf="itm.levelDesc && !isExpired(itm.expiryDate)">{{itm.levelDesc}}</span>
      <span class="expired" *ngIf="isExpired(itm.expiryDate)">{{'label.expired'|translate}}</span>
    </div>

    <div class="point-stamp-container"
      [ngStyle]="{'filter': isExpired(itm.expiryDate) ? 'opacity(0.7)' : 'opacity(1)' }">
      <div class="point"
        *ngIf="itm.rewardType === checkRewardType.point || itm.rewardType === checkRewardType.pointStamp"><span
          class="bold">{{itm.closingPoint}}</span><span>{{'label.points'
          | translate}}</span></div>
      <div class="stamps"
        *ngIf="itm.rewardType === checkRewardType.stamp || itm.rewardType === checkRewardType.pointStamp"><span
          class="bold">{{itm.stampEarned}}/{{itm.totalStamp}}</span><span>{{'label.stamps' | translate}}</span></div>
    </div>
  </div>
</div>


<div *ngIf="(isStorePage || isHomePage) && displayedMembership.length > 0 ">
  <div class="store-membership-card-container" [ngClass]="{'srbackground': !itm.membershipNo && showSRBanner}"
    *ngFor="let itm of displayedMembership" (click)="onClickMember(itm)">

    <ng-template [ngIf]="!itm.membershipNo && !showSRBanner">
      <div class="non-membership">
        <h1 class="bold">{{'desc.not.yet.membership'| translate}}</h1>
      </div>
    </ng-template>

    <ng-template [ngIf]="!itm.membershipNo && showSRBanner">
      <div class="membershipCard-SR">
        <img src="assets/SR-membership-banner/SRBanner.svg" alt="SR membership banner">
      </div>
    </ng-template>

    <ng-template [ngIf]="itm.membershipNo">
      <div class="membership-detail">
        <div class="pointStamp">
          <h1 class="pointStampText"
            [ngStyle]="{'color': isExpired(itm.expiryDate) ? 'var(--neutral-40)' : 'var(--text-primary)' }"
            *ngIf="itm.rewardType === checkRewardType.point || itm.rewardType === checkRewardType.pointStamp">
            {{itm.closingPoint}}<span class="label"
              [ngStyle]="{'color': isExpired(itm.expiryDate) ? 'var(--neutral-40)' : 'var(--text-primary)' }">{{'label.points'
              | translate}}</span></h1>

          <h1 class="pointStampText"
            [ngStyle]="{'color': isExpired(itm.expiryDate) ? 'var(--neutral-40)' : 'var(--text-primary)' }"
            *ngIf="itm.rewardType === checkRewardType.stamp || itm.rewardType === checkRewardType.pointStamp">
            {{itm.stampEarned}}<span class="label"
              [ngStyle]="{'color': isExpired(itm.expiryDate) ? 'var(--neutral-40)' : 'var(--text-primary)' }">{{'label.stamps'
              | translate}}</span></h1>
        </div>

        <div class="membershipNo"
          [ngStyle]="{'background-color': isExpired(itm.expiryDate) ? 'var(--system-red)' : 'var(--neutral-90)' }">
          <span>{{'label.id' | translate}}: </span>
          <span>{{itm.membershipNo?.length > 20 ? (itm.membershipNo | slice:0:20) + '...' : itm.membershipNo}}</span>
          <span *ngIf="isExpired(itm.expiryDate)">({{'label.expired' | translate}})</span>
        </div>
      </div>
    </ng-template>

    <!--with card image-->
    <img [src]="itm.cardImageData | storeImage" onerror="this.src='assets/image-unavailable.svg'" alt="membership card"
      [ngClass]="{'greyScale': isExpired(itm.expiryDate)}" *ngIf="itm.cardImageData"
      class="card-image" loading="lazy" [hidden]="showSRBanner && !itm.membershipNo" />

    <div class="logo-image-container" *ngIf="itm.logoImageData && !itm.cardImageData"
      [ngClass]="{'greyScale': isExpired(itm.expiryDate)}" [hidden]="showSRBanner && !itm.membershipNo">
      <img [src]="itm.logoImageData | storeImage" onerror="this.src='assets/image-unavailable.svg'" alt="image unavailable"
        loading="lazy" />
    </div>
  </div>
</div>

<div class="displayMultiple-membership-container" *ngIf="isDashboardMembership && displayedMembership.length > 0">
  <div class="displayMultiple-membership-listing" *ngFor="let itm of displayedMembership" (click)="onClickMember(itm)">
    <div class="multiple-card" [ngClass]="{'background-card': itm.logoImageData}">
      <img [src]="itm.logoImageData | storeImage" *ngIf="itm.logoImageData" onerror="this.src='assets/image-unavailable.svg'">
      <img [src]="(itm.cardImageData ? (itm.cardImageData | storeImage) : 'assets/image-unavailable.svg')" *ngIf="!itm.logoImageData" class="multiple-card-img" onerror="this.src='assets/image-unavailable.svg'">
    </div>
    <span *ngIf="itm.membershipDesc">{{itm.membershipDesc}}</span>
  </div>
</div>